const { test } = require('ramda')

module.exports = test(/Id$/)
